import { useAppState } from '../../client/providers/AppProvider';
import React from 'react';
import { NeedsOnboardingInformation, usePageRequireAuth } from '../../client/hooks';
import { DashboardFullPageLoading } from '../../components/common/GenericFullPageLoading';
import { DashboardLayout } from '../../components/common/layout/DashboardLayout';
import { PlayerSubscriptions } from '../../components/dashboard/subscriptions/PlayerSubscriptions';
import { Espin_Role_Enum } from '../../generated/spin-graphql';
import { CollegeSubscriptions } from '../../components/dashboard/subscriptions/CollegeSubscriptions';
import { loadStripe } from '@stripe/stripe-js';
import { getClientEnv } from '../../client/clientEnv';
import { ParentSubscriptions } from '../../components/dashboard/subscriptions/ParentSubscriptions';
import { HighSchoolSubscriptions } from '../../components/dashboard/subscriptions/HighSchoolSubscriptions';
const stripePromise = loadStripe(getClientEnv().NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY);
export default function SubscriptionsPage() {
    const { user } = useAppState();

    usePageRequireAuth({});

    if (!!!user) {
        return <DashboardFullPageLoading />;
    }

    let content = <CollegeSubscriptions />;
    let pageTitle = `My Subscription`;
    if (user.role === Espin_Role_Enum.EspinPlayerUser) {
        content = <PlayerSubscriptions />;
    }
    if (user.role === Espin_Role_Enum.EspinParentUser) {
        pageTitle = "My Player's Subscriptions";
        content = <ParentSubscriptions players={user.parent_profile?.child_profiles} />;
    }
    if (user.role === Espin_Role_Enum.EspinHighschoolUser) {
        pageTitle = 'My Schools Subscriptions';
        content = <HighSchoolSubscriptions />;
    }

    return (
        <DashboardLayout pageTitle={pageTitle}>
            <NeedsOnboardingInformation>{content}</NeedsOnboardingInformation>
        </DashboardLayout>
    );
}
